export const OSS_URL =
  "https://public-aaf-shenzhen-file.oss-cn-beijing.aliyuncs.com/webStatic/newCompany/";

export const BANNER_FILES = [
  "images/智联全球.jpg",
  "images/战略合作平台.jpg",
  "images/关于我们.jpg",
];

export const PAGE_BANNERS = {
  "/globalNetwork": "images/智联全球.jpg",
  "/platform": "images/战略合作平台.jpg",
  "/AMAZON": "images/战略合作平台.jpg",
  "/about": "images/关于我们.jpg",
  "/connection": "images/关于我们.jpg",
  "/corporateCulture": "images/关于我们.jpg",
  "/inviteJob": "images/关于我们.jpg",
};

export const JOIN_BANNER_FILES = {
  social: "images/social.jpg",
  campus: "images/campus.jpg",
};

const preloaded = new Set();

export function bannerUrl(file) {
  return OSS_URL + file;
}

export const JOIN_BANNER_URLS = {
  social: bannerUrl(JOIN_BANNER_FILES.social),
  campus: bannerUrl(JOIN_BANNER_FILES.campus),
};

export function getPageBannerSrc(path) {
  const file = PAGE_BANNERS[normalizePath(path)];
  return file ? bannerUrl(file) : "";
}

export function getJoinBannerSrc(tab) {
  return tab === "campus" ? JOIN_BANNER_URLS.campus : JOIN_BANNER_URLS.social;
}

export function isJoinPath(path) {
  const normalized = normalizePath(path);
  return normalized === "/join" || normalized.startsWith("/join/");
}

export function preloadJoinBanners(currentTab = "social") {
  const current = getJoinBannerSrc(currentTab);
  const other = currentTab === "campus" ? JOIN_BANNER_URLS.social : JOIN_BANNER_URLS.campus;
  preloadImage(current, { fetchPriority: "high" });
  preloadImage(other, { fetchPriority: "high" });
}

export function preloadBannerByPath(path, fetchPriority = "high") {
  if (isJoinPath(path)) {
    const tab = normalizePath(path) === "/join/campus" ? "campus" : "social";
    preloadJoinBanners(tab);
    return;
  }
  const src = getPageBannerSrc(path);
  if (src) preloadImage(src, { fetchPriority });
}

export function preloadAllBannersIdle() {
  const run = () => {
    BANNER_FILES.forEach((file) => preloadImage(bannerUrl(file)));
    Object.keys(JOIN_BANNER_FILES).forEach((key) => {
      preloadImage(bannerUrl(JOIN_BANNER_FILES[key]));
    });
  };
  if (typeof window === "undefined") return;
  if (typeof window.requestIdleCallback === "function") {
    window.requestIdleCallback(run, { timeout: 1800 });
  } else {
    setTimeout(run, 600);
  }
}

export function preloadImage(url, { fetchPriority = "low" } = {}) {
  if (!url || typeof window === "undefined" || preloaded.has(url)) return;
  preloaded.add(url);
  if (fetchPriority === "high") {
    injectHeadPreload(url);
  }
  const img = new Image();
  if (fetchPriority) {
    img.fetchPriority = fetchPriority;
  }
  img.decoding = "async";
  img.src = url;
}

function normalizePath(path) {
  if (!path) return "/";
  const clean = path.split("?")[0].split("#")[0];
  if (clean.length > 1 && clean.endsWith("/")) {
    return clean.slice(0, -1);
  }
  return clean || "/";
}

function injectHeadPreload(url) {
  if (document.querySelector(`link[rel="preload"][href="${url}"]`)) return;
  const link = document.createElement("link");
  link.rel = "preload";
  link.as = "image";
  link.href = url;
  link.fetchPriority = "high";
  document.head.appendChild(link);
}
